import { createGlobalStyle } from 'styled-components';
import { respondTo } from '../utils/responsive';

const GlobalStyle = createGlobalStyle`
  /* CSS Reset */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  
  button, a {
    // reset all styles
    all: unset;
    box-sizing: border-box;
  }

  /* Your existing global styles */
  * {
    box-sizing: border-box;
  }

  body {
    font-family: 'Noto Sans TC', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  :root {
    --main-color-a: #FFDF5A;
    --main-color-b: #FFEEA6;
    --main-color-c: #FAA57E;
    --main-color-d: #99B3F0;
    --main-color-e: #2B3247;

    --neutrals-000: #fff;
    --neutrals-050: #F8FAFC;
    --neutrals-100: #f1f5f9;
    --neutrals-200: #e2e8f0;
    --neutrals-300: #cbd5e1;
    --neutrals-400: #94a3b8;
    --neutrals-500: #64748b;
    --neutrals-600: #475569;
    --neutrals-700: #334155;
    --neutrals-800: #1e293b;
    --neutrals-900: #0f172a;
    
    --shadow: 8px 9px 4px 0px rgba(0, 0, 0, 0.25);
    --shadow-m: 5px 5px 4px 0px rgba(0, 0, 0, 0.35);

    --headline-1: 800 54px/120% 'Noto Sans TC';
    --headline-2: 800 42px/120% 'Noto Sans TC';
    --headline-3: 800 36px/125% 'Noto Sans TC';
    --headline-4: 800 30px/130% 'Noto Sans TC';
    --headline-5: 800 24px/130% 'Noto Sans TC';
    --headline-6: 800 20px/135% 'Noto Sans TC';
    --paragraph-1: 600 18px/135% 'Noto Sans TC';
    --paragraph-2: 400 16px/130% 'Noto Sans TC';
    --small-text-1: 400 14px/130% 'Noto Sans TC';
    --small-text-2: 400 12px/130% 'Noto Sans TC';

    --time-countdown: 400 40px/120% 'Bungee', sans-serif;
    --chapter: 400 30px/120% 'Bungee', sans-serif;
    --button: 400 24px 'Baloo Paaji 2', sans-serif;

    --mobile-headline-1: 800 36px/120% 'Noto Sans TC';
    --mobile-headline-2: 800 30px/120% 'Noto Sans TC';
    --mobile-headline-3: 800 24px/125% 'Noto Sans TC';
    --mobile-headline-4: 800 20px/130% 'Noto Sans TC';
    --mobile-headline-5: 800 18px/130% 'Noto Sans TC';
    --mobile-headline-6: 800 16px/135% 'Noto Sans TC';
    --mobile-paragraph-1: 600 16px/135% 'Noto Sans TC';
    --mobile-paragraph-2: 400 14px/130% 'Noto Sans TC';
    --mobile-small-text-1: 400 12px/130% 'Noto Sans TC';
    --mobile-small-text-2: 400 10px/130% 'Noto Sans TC';
    --mobile-time-countdown: 400 28px/120% 'Bungee', sans-serif;
    --mobile-chapter: 400 20px/120% 'Bungee', sans-serif;
    --mobile-button: 400 16px 'Baloo Paaji 2', sans-serif;

    --header-height: 88px;
    --font-baloon: 'Baloo Paaji 2', sans-serif;

    ${respondTo.sm} {
      --header-height: 64px;
    }

  }


`;

export default GlobalStyle; 